import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/main.css'
import './global-variables/global_variables'
import * as Sentry from "@sentry/vue";

Sentry.init({
    Vue,
    dsn: "https://eb8f0386ea3fe45be80c93e59bece7a5@o4509145241550848.ingest.de.sentry.io/4509145243844688"
});

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
